import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import styles from './rentrolllist.module.css';
import { Link } from "react-router-dom";
import dayjs from 'dayjs';

const RentRollList = ({ rentrollList }) => {

    return (<div className={`${styles.IncomeListUnderSec}`}>

        {rentrollList?.map((item, index) => {
            return <div key={index} className={`${styles.ListCardDivSec}`}>
                <div className={`${styles.CardDivList}`}>
                    <div className={`${styles.FirstSec} ${styles.ProfileImg}`}>
                        {/* <img src="/static/img/avatars/avatar-4.jpg" alt="" /> */}
                        <div>
                            <p className={`${styles.Name} ${styles.Hover}`}>
                                {item?.current_tenant ? <Link to={'/people/tenants/details/' + item?.current_tenant}>{item?.tenant_name}</Link> : '-'}
                            </p>
                            <p className={`${styles.Name} ${styles.Hover}`}>
                                <Link to={'/properties/details/' + item?.property_id}>{item?.property_name} - {item?.apt_no}</Link>
                            </p>
                        </div>
                    </div>
                    <div className={`${styles.SecondSec}`}>
                        <p className={`${styles.Name}`}>
                            <span>BD/BA: <span>{item?.bd_ba}</span></span>
                            <span className={`${styles.Second}`}>Sqft: <span>{item?.size}</span></span>
                        </p>
                        <p className={`${styles.Name}`}>
                            <span>Rent: <span>{item?.actual_rent !== '' ? '$' + item?.actual_rent : '-'}</span></span>
                            <span className={`${styles.Second}`}><span>Deposit: {item?.security_deposit !== '' ? '$' + item?.security_deposit : '-'}</span></span>
                        </p>
                    </div>
                    <div className={`${styles.ThirdSec}`}>          
                        {item?.current_status === 2 && <span className={`${styles.StatusBadge} ${styles.Confirm}`}>Rented</span>}
                        {item?.current_status === 1 && <span className={`${styles.StatusBadge} ${styles.NotVerified}`}>Available</span>}
                        {item?.current_status !== 1 && item?.current_status !== 2 && <span className={`${styles.StatusBadge} ${styles.Failed}`}>Not Available</span>}
                        <p className={`${styles.Name}`}>
                            <span>Move-In: <span>{item?.movein_date !== '' ? dayjs(item?.movein_date).format('MM-DD-YYYY') : '-'}</span></span>
                        </p>
                    </div>
                </div>
            </div>
        })}

        {rentrollList?.length > 0 && <TableContainer className={`${styles.TableDiv} CustomTableDiv`}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 200 }}>Property</TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 100 }}>Unit</TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 120 }}>BD/BA</TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 180 }}>Tenant</TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 150 }}>Status</TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 120 }}>Sqft</TableCell>
                        {/*<TableCell className={`${styles.TableHead}`} style={{ width: 150 }}>Market Rent</TableCell>*/}
                        <TableCell className={`${styles.TableHead}`} style={{ width: 150 }}>Rent</TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 150 }}>Deposit</TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 150 }}>Move-In</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rentrollList?.map((item, index) => {
                        return <TableRow key={index}>
                            <TableCell className={`${styles.TableBodyText} ${styles.ProfileImg} ${styles.Hover}`}><Link to={'/properties/details/' + item?.property_id}><span>{item?.property_name}</span></Link></TableCell>
                            <TableCell className={`${styles.TableBodyText}`}>{item?.apt_no}</TableCell>
                            <TableCell className={`${styles.TableBodyText}`}>{item?.bd_ba}</TableCell>
                            <TableCell className={`${styles.TableBodyText} ${styles.ProfileImg} ${styles.Hover}`}>{item?.current_tenant ? <Link to={'/people/tenants/details/' + item?.current_tenant}><span>{item?.tenant_name}</span></Link> : '-'}</TableCell>
                            <TableCell className={`${styles.TableBodyText}`}>
                                {item?.current_status === 2 && <span className={`${styles.StatusBadge} ${styles.Confirm}`}>Rented</span>}
                                {item?.current_status === 1 && <span className={`${styles.StatusBadge} ${styles.NotVerified}`}>Available</span>}
                                {item?.current_status !== 1 && item?.current_status !== 2 && <span className={`${styles.StatusBadge} ${styles.Failed}`}>Not Available</span>}
                            </TableCell>
                            <TableCell className={`${styles.TableBodyText}`}>{item?.size}</TableCell>
                            {/*<TableCell className={`${styles.TableBodyText}`}>{item?.market_rent !== '' ? '$' + item?.market_rent : '-'}</TableCell>*/}
                            <TableCell className={`${styles.TableBodyText}`}>{item?.actual_rent !== '' ? '$' + item?.actual_rent : '-'}</TableCell>
                            <TableCell className={`${styles.TableBodyText}`}>{item?.security_deposit !== '' ? '$' + item?.security_deposit : '-'}</TableCell>
                            <TableCell className={`${styles.TableBodyText}`}>{item?.movein_date !== '' ? dayjs(item?.movein_date).format('MM-DD-YYYY') : '-'}</TableCell>
                        </TableRow>
                    })}

                </TableBody>
            </Table>
        </TableContainer>}

        {rentrollList?.length === 0 && <div className={`${styles.NoDataMain}`}>
            <div className={`${styles.NoDataIMG}`}>
                <img src="/static/img/no-report.png" alt="No Data" />
            </div>
            <p className={`${styles.NoDataText}`}>Rent roll list is currently empty.</p>
            <p className={`${styles.NoDataTextSub}`}>All your reports will appear here once available.</p>
        </div>}

    </div>);
}

export default RentRollList;